import React, { useRef, useState } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaVolumeUp, FaVolumeMute, FaYoutube } from "react-icons/fa";
import ServicesSection from "../components/layout/ServicesSection";
import ProductLanding from "../components/layout/ProductLanding";
import TestimonialsSection from "../components/layout/TestimonialsSection";

const LandingPage = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleAudio = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  return (
    <div style={{ width: "100%", minHeight: "100vh", background: "#111", padding: "20px" }}>
      {/* Container */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "40px",
        }}
      >
        {/* VIDEO LEFT */}
        <div
          style={{
            flex: "1",
            minWidth: "300px",
            maxHeight: "600px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            borderRadius: "16px",
            position: "relative",
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            loop
            muted
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "16px",
            }}
          >
            <source src="/images/Braj-2.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Audio toggle button */}
          <button
            onClick={toggleAudio}
            style={{
              position: "absolute",
              bottom: "20px",
              right: "20px",
              background: "#d4af37",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            }}
          >
            {/* @ts-ignore */}
            {isMuted ? <FaVolumeMute color="#000" /> : <FaVolumeUp color="#000" />}
          </button>
        </div>

        {/* USER PROFILE RIGHT */}
        <div
          style={{
            flex: "1",
            minWidth: "300px",
            maxWidth: "400px",
            background: "#000",
            borderRadius: "16px",
            padding: "50px 30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
          }}
        >
          {/* Profile Image */}
          <img
            src="./logo.png"
            alt="User Profile"
            style={{
              width: "160px",
              height: "160px",
              borderRadius: "50%",
              objectFit: "cover",
              marginBottom: "30px",
              border: "4px solid #d4af37",
            }}
          />

          {/* Name */}
          <h2
            style={{
              color: "#d4af37",
              fontSize: "32px",
              fontWeight: "700",
              marginBottom: "10px",
              textAlign: "center",
            }}
          >
            Shubham Pratap Singh
          </h2>

          {/* Role */}
          <p
            style={{
              color: "#fff",
              fontSize: "18px",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            Welcome to Braj Decor And Designers Varanasi, where creativity meets functionality.
          </p>

          {/* Short Bio */}
          <p
            style={{
              color: "#ccc",
              fontSize: "16px",
              textAlign: "center",
              lineHeight: "1.6",
            }}
          >
           🛠️ Our Services

✨ Interior Designing
✨ Home & Office Decoration
✨ Modular Kitchen & Wardrobe
✨ False Ceiling & Lighting
✨ Wallpaper, Paint & Polish Work
✨ Custom Furniture & Wooden Work
✨ Turnkey Interior Projects
          </p>

          {/* Social Icons */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginTop: "30px",
            }}
          >
            {/* @ts-ignore */}
            <a href="https://www.facebook.com/profile.php?id=61585600680876"><FaFacebookF color="#d4af37" size={24} /></a>
            {/* @ts-ignore */}
            <a href="https://www.instagram.com/brajdecoranddesigners/"><FaInstagram color="#d4af37" size={24} /></a>
            {/* @ts-ignore */}
            <a href="https://www.youtube.com/@brajdecoranddesigner1420"><FaYoutube color="#d4af37" size={24} /></a>
          </div>
        </div>
      </div>
     {/* Services Section */}
     <ServicesSection/>
     {/* Services Section */} 

     {/* Peoduct Landing */}
      <ProductLanding/>
      {/* Peoduct Landing */}

      {/* Testimonials */}
     <TestimonialsSection/>
      {/* Testimonials */} 
       
      {/* RESPONSIVE */}
     
    </div>
  );
};

export default LandingPage;
